import { useTenantDetails } from '@/hooks/useConnections';

interface OnboardingStatusOptions {
  enabled?: boolean;
}

interface OnboardingStatusResult {
  isComplete: boolean;
  isLoading: boolean;
}

/**
 * Hook to check if onboarding is complete for the current tenant.
 *
 * Reads `is_onboarded` directly from the tenant details payload
 * returned by `GET /api/v1/session/tenant`.
 *
 * @param options - Options. Pass `enabled: false` to skip the check
 *                  (e.g. when no org is active yet).
 * @returns Onboarding status with loading state.
 */
export function useOnboardingStatus (options?: OnboardingStatusOptions): OnboardingStatusResult {
  const { data: tenantDetails, isLoading: isTenantLoading } = useTenantDetails({
    enabled: options?.enabled,
  });

  if (isTenantLoading) {
    return { isComplete: false, isLoading: true };
  }

  return {
    isComplete: tenantDetails?.tenant?.is_onboarded === true,
    isLoading: false,
  };
}
